/* ============================================================
   King Wishlist — localStorage based, no app / no login needed
   - Injects a small heart button on every product card
   - Saves products (handle, title, price, image, url) per device
   - Updates the header heart count badge
   - Renders the /pages/wishlist page grid
   ============================================================ */
(function () {
  var BASE_KEY = 'king_wishlist_v1';

  /* ---------- per-customer storage key ----------
     When a customer is logged in, the wishlist is stored under a key tied to
     their customer id, so each account keeps its own list on this device.
     (True cross-device sync requires a backend/app — see notes.) */
  function customerId() {
    return (window.__kingCustomer && window.__kingCustomer.loggedIn && window.__kingCustomer.id)
      ? window.__kingCustomer.id : null;
  }
  function storageKey() {
    var id = customerId();
    return id ? (BASE_KEY + '_c' + id) : BASE_KEY;
  }
  // If a guest saved items and then logged in, move those items into their account bucket.
  function mergeGuestIntoCustomer() {
    var id = customerId();
    if (!id) return;
    var custKey = BASE_KEY + '_c' + id;
    var guest = [];
    try { guest = JSON.parse(localStorage.getItem(BASE_KEY)) || []; } catch (e) {}
    if (!guest.length) return;
    var cust = [];
    try { cust = JSON.parse(localStorage.getItem(custKey)) || []; } catch (e) {}
    guest.forEach(function (g) {
      if (!cust.some(function (c) { return c.handle === g.handle; })) cust.unshift(g);
    });
    try { localStorage.setItem(custKey, JSON.stringify(cust)); } catch (e) {}
    try { localStorage.removeItem(BASE_KEY); } catch (e) {}
  }

  /* ---------- storage helpers ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(storageKey())) || []; }
    catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(storageKey(), JSON.stringify(items)); } catch (e) {}
    updateBadge();
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function toggle(item) {
    var items = read();
    var idx = -1;
    for (var i = 0; i < items.length; i++) { if (items[i].handle === item.handle) { idx = i; break; } }
    if (idx >= 0) { items.splice(idx, 1); }
    else { items.unshift(item); }
    write(items);
    return idx < 0; // true if now saved
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }

  /* ---------- parsing helpers ---------- */
  function handleFromUrl(url) {
    if (!url) return '';
    var clean = url.split('?')[0].split('#')[0];
    var m = clean.match(/\/products\/([^\/]+)/);
    return m ? m[1] : '';
  }
  function bgUrl(el) {
    if (!el) return '';
    var bg = el.style.backgroundImage || (window.getComputedStyle ? getComputedStyle(el).backgroundImage : '');
    var m = bg && bg.match(/url\(["']?(.*?)["']?\)/);
    return m ? m[1] : '';
  }
  // Robust image getter: background-image, else a nested <img> (src/currentSrc/srcset/data-src),
  // else the element itself if it is an <img>. Guarantees the wishlist page shows product images.
  function imgFrom(el) {
    if (!el) return '';
    var bg = bgUrl(el);
    if (bg) return bg;
    var im = (el.tagName === 'IMG') ? el : (el.querySelector ? el.querySelector('img') : null);
    if (im) {
      var src = im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src') || '';
      if (!src) {
        var ss = im.getAttribute('srcset') || im.getAttribute('data-srcset') || '';
        if (ss) src = ss.split(',')[0].trim().split(' ')[0];
      }
      if (src && src.indexOf('//') === 0) src = 'https:' + src;
      return src || '';
    }
    return '';
  }
  var HEART = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 10-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 000-7.8z"/></svg>';

  // Store product data on the button; clicks handled by ONE delegated listener below,
  // so hearts work everywhere — including grid cards Dawn re-renders on filter/sort.
  function attachToggle(btn, item) {
    if (item) {
      if (!btn.getAttribute('data-wl-handle')) btn.setAttribute('data-wl-handle', item.handle || '');
      if (!btn.getAttribute('data-wl-url'))    btn.setAttribute('data-wl-url', item.url || '#');
      if (!btn.getAttribute('data-wl-title'))  btn.setAttribute('data-wl-title', item.title || '');
      if (!btn.getAttribute('data-wl-price'))  btn.setAttribute('data-wl-price', item.price || '');
      if (!btn.getAttribute('data-wl-image') && item.image) btn.setAttribute('data-wl-image', item.image);
      if (has(item.handle)) btn.classList.add('is-saved');
    }
  }

  // Delegated click handler (capture phase) — reliable for every heart, now and after re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.wl-heart') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var item = {
      handle: btn.getAttribute('data-wl-handle') || '',
      url: btn.getAttribute('data-wl-url') || '#',
      title: btn.getAttribute('data-wl-title') || '',
      price: btn.getAttribute('data-wl-price') || '',
      image: btn.getAttribute('data-wl-image') || ''
    };
    if (!item.handle) return;
    var nowSaved = toggle(item);
    btn.classList.toggle('is-saved', nowSaved);
    btn.classList.add('wl-pop');
    setTimeout(function () { btn.classList.remove('wl-pop'); }, 300);
  }, true);

  /* ---------- bind server-rendered hearts (data-wl-*) ---------- */
  function bindServerHearts() {
    var hearts = document.querySelectorAll('.wl-heart[data-wl-handle]');
    for (var i = 0; i < hearts.length; i++) {
      var btn = hearts[i];
      var img = btn.getAttribute('data-wl-image') || '';
      if (!img) {
        // fall back to the card image so the wishlist page never shows a blank box
        var imgWrap = btn.closest('.product-img, .d-img, .ltd-img') || btn.parentElement;
        var card = btn.closest('.product, .d-card, .ltd-card');
        img = imgFrom(imgWrap) || imgFrom(card);
      }
      attachToggle(btn, {
        handle: btn.getAttribute('data-wl-handle'),
        url: btn.getAttribute('data-wl-url') || '#',
        title: btn.getAttribute('data-wl-title') || '',
        price: btn.getAttribute('data-wl-price') || '',
        image: img
      });
    }
  }

  /* ---------- inject hearts on cards that don't already have one ---------- */
  function injectHearts() {
    bindServerHearts();
    var imgs = document.querySelectorAll('.product-img, .d-img, .ltd-img');
    for (var k = 0; k < imgs.length; k++) {
      (function (img) {
        if (img.querySelector('.wl-heart')) return; // already has a heart
        var href = img.getAttribute('href') || '';
        var card = img.closest('.product, .d-card, .ltd-card') || img.parentElement;
        var titleEl = card ? card.querySelector('h4, h5') : null;
        var handle = handleFromUrl(href);
        if (!handle && titleEl) {
          handle = titleEl.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        }
        if (!handle) return;
        var priceEl = card ? card.querySelector('.price, .d-meta p, p') : null;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wl-heart';
        btn.setAttribute('aria-label', 'Add to wishlist');
        btn.innerHTML = HEART;
        attachToggle(btn, {
          handle: handle,
          url: href,
          title: titleEl ? titleEl.textContent.trim() : handle,
          price: priceEl ? priceEl.textContent.trim() : '',
          image: imgFrom(img) || imgFrom(card)
        });
        img.appendChild(btn);
      })(imgs[k]);
    }
  }

  /* ---------- header count badge ---------- */
  function updateBadge() {
    var count = read().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].style.display = count > 0 ? '' : 'none';
    }
  }

  /* ---------- wishlist page render ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }
  function cardHtml(i) {
    var media = i.image
      ? '<a class="wl-card-img" href="' + i.url + '"><img class="wl-card-photo" src="' + i.image + '" alt="' + esc(i.title) + '" loading="lazy"></a>'
      : '<a class="wl-card-img wl-card-img--empty" href="' + i.url + '"></a>';
    return (
      '<article class="wl-card" data-handle="' + i.handle + '">' +
        media +
        '<button type="button" class="wl-remove" data-handle="' + i.handle + '" aria-label="Remove">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="wl-card-meta">' +
          '<h4><a href="' + i.url + '">' + (i.title || 'Product') + '</a></h4>' +
          (i.price ? '<p class="price">' + i.price + '</p>' : '') +
          '<a class="wl-card-btn" href="' + i.url + '">View product</a>' +
        '</div>' +
      '</article>'
    );
  }

  // For any saved item missing an image, look up the real product and fill it in,
  // so the wishlist always shows the product (not just its name).
  function enrichMissing() {
    var items = read();
    var missing = items.filter(function (i) { return i.handle && !i.image && !i.enrichTried; });
    if (!missing.length) return;
    var pending = missing.length, changed = false;
    missing.forEach(function (it) {
      fetch('/products/' + it.handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          it.enrichTried = true; changed = true;
          if (p) {
            var im = p.featured_image || (p.images && p.images[0]) || '';
            if (im && im.indexOf('//') === 0) im = 'https:' + im;
            if (im) it.image = im;
            if (!it.title) it.title = p.title;
            if (!it.url || it.url === '#') it.url = '/products/' + p.handle;
          }
        })
        .catch(function () { it.enrichTried = true; changed = true; })
        .then(function () {
          pending--;
          if (pending === 0 && changed) {
            try { localStorage.setItem(storageKey(), JSON.stringify(items)); } catch (e) {}
            renderPage();
          }
        });
    });
  }

  function renderPage() {
    var grid = document.getElementById('wishlistGrid');
    if (!grid) return;
    var empty = document.getElementById('wishlistEmpty');
    var items = read();

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.innerHTML = items.map(cardHtml).join('');

    var btns = grid.querySelectorAll('.wl-remove');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        remove(this.getAttribute('data-handle'));
        renderPage();
      });
    }
    enrichMissing();
  }

  /* ---------- init ---------- */
  function init() {
    mergeGuestIntoCustomer();
    injectHearts();
    updateBadge();
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-inject for carousels / sections that hydrate slightly later
  setTimeout(injectHearts, 700);
  setTimeout(injectHearts, 1800);

  // Expose for theme-editor section reloads
  document.addEventListener('shopify:section:load', init);

  window.KingWishlist = { read: read, updateBadge: updateBadge, renderPage: renderPage, injectHearts: injectHearts };
})();
